// import { Link } from "react-router-dom";
// import {
//     Users,
//     Globe,
//     Zap,
//     TrendingUp,
//     Sparkles,
//     ArrowRight,
//     Target,
//     Rocket,
//     Heart,
//     Shield,
//     Play,
//     Award,
//     Star,
//     MonitorSmartphone,
//     BadgeCheck,
//     Video,
//     Palette,
//     BarChart3,
// } from "lucide-react";
// import BackToTop from "../../components/BackToTop/BackToTop";
// import { useEffect, useState } from "react";
// import Footer from "../../layouts/Footer";
// import Header from "../../layouts/Header";
// import HeroBg from "../../../src/images/hero-bg.png";
// import AuthPopup from "../../components/popup/AuthPopup";


// const About = () => {

//     const [showAuth, setShowAuth] = useState(false);

//     // Platform features
// const features = [
//     {
//         icon: Video,
//         title: "Social to TV Conversion",
//         description: "Transform Instagram Reels, TikTok videos, and YouTube content into TV-ready ads automatically.",
//         color: "from-blue-500 to-cyan-500",
//         stats: "3x faster creation"
//     },
//     {
//         icon: MonitorSmartphone,
//         title: "Multi-Platform Delivery",
//         description: "Deploy campaigns across Roku, Amazon Fire TV, Samsung TV, and Apple TV with one click.",
//         color: "from-purple-500 to-pink-500",
//         stats: "10+ platforms"
//     },
//     {
//         icon: BarChart3,
//         title: "Real-Time Analytics",
//         description: "Track performance across all channels with unified dashboard and actionable insights.",
//         color: "from-green-500 to-emerald-500",
//         stats: "Live reporting"
//     },
//     {
//         icon: Palette,
//         title: "Creative Optimization",
//         description: "AI-powered tools to enhance and adapt your social content for the big screen.",
//         color: "from-orange-500 to-red-500",
//         stats: "4K quality"
//     }
// ];

//     // Statistics with icons
//     const stats = [
//         { value: "10K+", label: "Ads Generated", icon: Play, change: "+156% YoY" },
//         { value: "4K+", label: "Active Brands", icon: Users, change: "+89% YoY" },
//         { value: "120+", label: "Countries", icon: Globe, change: "Global reach" },
//         { value: "98%", label: "Satisfaction", icon: Star, change: "Top rated" }
//     ];

//     // Values with descriptions
// const values = [
//     {
//         icon: Rocket,
//         title: "Innovation First",
//         description: "We're constantly pushing the boundaries of what's possible in advertising technology.",
//         color: "bg-blue-50",
//         iconColor: "text-blue-600"
//     },
//     {
//         icon: Heart,
//         title: "Customer Obsessed",
//         description: "Your success is our success. We build features that solve real problems.",
//         color: "bg-red-50",
//         iconColor: "text-red-600"
//     },
//     {
//         icon: Shield,
//         title: "Trust & Transparency",
//         description: "Clear pricing, honest communication, and data privacy are our foundations.",
//         color: "bg-green-50",
//         iconColor: "text-green-600"
//     },
//     {
//         icon: Target,
//         title: "Results Driven",
//         description: "Every feature is measured by the impact it creates for our customers.",
//         color: "bg-purple-50",
//         iconColor: "text-purple-600"
//     }
// ];


//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     return (
//         <div className="bg-gradient-to-b from-gray-50 to-white">
//             <BackToTop />

//             {/* ================= HEADER ================= */}
//             <Header loginClick={() => { setShowAuth(true) }} />



//             <div className="relative">

//                 <div className="absolute inset-0 w-full h-full">
//                     <img
//                         src={HeroBg}
//                         loading="lazy"
//                         sizes="(max-width: 1440px) 100vw, 1440px"
//                         alt="hero"
//                         className="w-full h-full object-cover"
//                     />
//                 </div>

//                 {/* <div className="absolute inset-0 overflow-hidden">
//                     <div className="absolute bottom-0 -right-40 w-[400px] h-[400px] bg-gradient-to-l from-pink-200/20 via-purple-200/20 to-indigo-200/20 rounded-full blur-3xl animate-float-slower"></div>
//                     <div className="absolute top-0 -left-40 w-[400px] h-[400px] bg-gradient-to-r from-indigo-200/20 via-purple-200/20 to-pink-200/20 rounded-full blur-3xl animate-float-slow"></div>

//                     {[...Array(50)].map((_, i) => (
//                         <div
//                             key={i}
//                             className="absolute w-1 h-1 bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full animate-float-particle"
//                             style={{
//                                 left: `${Math.random() * 100}%`,
//                                 top: `${Math.random() * 100}%`,
//                                 animationDelay: `${Math.random() * 8}s`,
//                                 animationDuration: `${15 + Math.random() * 15}s`,
//                                 opacity: 0.3,
//                             }}
//                         />
//                     ))}
//                 </div> */}


//                 <div className="relative pt-16 md:pt-20">
//                     {/* Hero Section with animated gradient */}
//                     <section className="relative max-w-7xl mx-auto px-6 py-20 overflow-hidden">
//                         {/* Animated background */}
//                         {/* <div className="absolute inset-0 -z-10">
//                             <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gradient-to-r from-indigo-600/5 to-purple-600/5 rounded-full blur-3xl animate-pulse"></div>
//                             <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-blue-600/5 rounded-full blur-3xl"></div>
//                             <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-purple-600/5 rounded-full blur-3xl"></div>
//                         </div> */}

//                         <div className="text-center max-w-4xl mx-auto">
//                             <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-8 border border-indigo-100">
//                                 <Sparkles className="h-4 w-4 text-indigo-600" />
//                                 <span className="text-sm font-medium bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
//                                     About SocialTV
//                                 </span>
//                             </div>

//                             <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
//                                 Turning Social Content Into{' '}
//                                 <span className="relative">
//                                     <span className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
//                                         TV Ads
//                                     </span>
//                                     <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-full"></div>
//                                 </span>
//                             </h1>

//                             {/* <h1 className="text-5xl md:text-6xl font-bold mb-4">
//                         Turning Social Content Into{' '}
//                         <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
//                             TV Ads
//                         </span>
//                     </h1> */}

//                             <p className="text-xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
//                                 SocialTV helps brands transform their social media videos into
//                                 powerful Connected TV ads in minutes. Our platform bridges the gap
//                                 between social content and premium TV advertising.
//                             </p>

//                             {/* Trust indicators */}
//                             {/* <div className="flex items-center justify-center gap-8 mt-12">
//                         <div className="flex items-center gap-2">
//                             <div className="flex -space-x-2">
//                                 {[1, 2, 3, 4].map((i) => (
//                                     <img
//                                         key={i}
//                                         src={`https://images.unsplash.com/photo-${i === 1 ? '1494790108777-466d103eb9cb' : i === 2 ? '1507003211169-0a1dd7228f2d' : i === 3 ? '1438761681033-6461ffad8d80' : '1500648767791-00dcc994a37e'}?ixlib=rb-4.0.3&auto=format&fit=crop&w=32&h=32&q=80`}
//                                         className="w-8 h-8 rounded-full border-2 border-white"
//                                         alt="User"
//                                     />
//                                 ))}
//                             </div>
//                             <span className="text-sm text-gray-500">Trusted by 4,000+ brands</span>
//                         </div>
//                         <div className="h-4 w-px bg-gray-200"></div>
//                         <div className="flex items-center gap-1">
//                             <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
//                             <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
//                             <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
//                             <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
//                             <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
//                             <span className="text-sm text-gray-500 ml-1">4.9/5 rating</span>
//                         </div>
//                     </div> */}
//                         </div>
//                     </section>

//                     {/* Stats Section with hover effects */}
//                     <section className="max-w-7xl mx-auto px-6 pb-24">
//                         <div className="grid md:grid-cols-4 gap-6">
//                             {stats.map((stat, i) => (
//                                 <div
//                                     key={i}
//                                     className="group relative bg-white p-8 rounded-2xl border border-gray-200 hover:border-indigo-600/20 hover:shadow-xl transition-all hover:-translate-y-1"
//                                 >
//                                     <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/5 to-purple-600/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity"></div>

//                                     <div className="relative">
//                                         <div className="w-12 h-12 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
//                                             <stat.icon className="h-6 w-6 text-indigo-600" />
//                                         </div>

//                                         <h3 className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</h3>
//                                         <p className="text-sm text-gray-500 mb-3">{stat.label}</p>

//                                         <div className="inline-flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full">
//                                             <TrendingUp className="h-3 w-3" />
//                                             {stat.change}
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </section>

//                     {/* Story Section with image */}
//                     <section className="max-w-7xl mx-auto px-6 pb-24">
//                         <div className="grid lg:grid-cols-2 gap-16 items-center">
//                             <div className="relative">
//                                 <div className="absolute -inset-4 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-3xl blur-xl opacity-20"></div>
//                                 <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
//                                     <img
//                                         src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
//                                         alt="Team collaboration"
//                                         className="w-full h-96 object-cover"
//                                     />
//                                     {/* <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm rounded-xl p-4 border border-white/20">
//                                 <div className="flex items-center gap-4">
//                                     <PlayCircle className="h-10 w-10 text-indigo-600" />
//                                     <div>
//                                         <div className="font-medium text-gray-900">Watch our story</div>
//                                         <div className="text-sm text-gray-500">2 min • Behind the scenes</div>
//                                     </div>
//                                 </div>
//                             </div> */}
//                                 </div>
//                             </div>

//                             <div>
//                                 <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-6">
//                                     <Target className="h-4 w-4 text-indigo-600" />
//                                     <span className="text-sm font-medium text-indigo-600">Our Mission</span>
//                                 </div>

//                                 <h2 className="text-4xl font-bold text-gray-900 mb-6">
//                                     Bridging Social &{' '}
//                                     <span className="text-indigo-600">Television</span>
//                                 </h2>

//                                 <div className="space-y-4 text-gray-600">
//                                     <p className="leading-relaxed">
//                                         Advertising is evolving. Social media has become the most powerful
//                                         form of storytelling, but television remains the most trusted
//                                         screen in the home.
//                                     </p>

//                                     <p className="leading-relaxed">
//                                         SocialTV was created to connect these two worlds — enabling
//                                         businesses to easily transform social content into high-quality
//                                         TV-ready ads.
//                                     </p>

//                                     <p className="leading-relaxed">
//                                         Our platform simplifies the entire workflow, allowing brands,
//                                         agencies, and creators to launch TV campaigns faster than ever
//                                         before.
//                                     </p>
//                                 </div>

//                                 {/* Company highlights */}
//                                 <div className="grid grid-cols-2 gap-4 mt-8">
//                                     <div className="flex items-center gap-3">
//                                         <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center">
//                                             <BadgeCheck className="h-5 w-5 text-green-600" />
//                                         </div>
//                                         <div>
//                                             <div className="font-medium text-gray-900">ISO Certified</div>
//                                             <div className="text-xs text-gray-500">Security & privacy</div>
//                                         </div>
//                                     </div>
//                                     <div className="flex items-center gap-3">
//                                         <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center">
//                                             <Award className="h-5 w-5 text-blue-600" />
//                                         </div>
//                                         <div>
//                                             <div className="font-medium text-gray-900">Award Winning</div>
//                                             <div className="text-xs text-gray-500">Best AdTech 2024</div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>

//                     {/* Features Grid */}
//                     <section className="max-w-7xl mx-auto px-6 pb-24">
//                         <div className="text-center max-w-2xl mx-auto mb-16">
//                             <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-4">
//                                 <Zap className="h-4 w-4 text-indigo-600" />
//                                 <span className="text-sm font-medium text-indigo-600">Platform Features</span>
//                             </div>
//                             <h2 className="text-4xl font-bold text-gray-900 mb-4">
//                                 Everything You Need to Succeed
//                             </h2>
//                             <p className="text-lg text-gray-500">
//                                 Powerful tools that make TV advertising accessible to everyone
//                             </p>
//                         </div>

//                         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//                             {features.map((feature, i) => (
//                                 <div
//                                     key={i}
//                                     className="group relative bg-white p-8 rounded-2xl border border-gray-100 hover:border-transparent hover:shadow-xl transition-all hover:-translate-y-1"
//                                 >
//                                     <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity`}></div>

//                                     <div className="relative">
//                                         <div className={`w-14 h-14 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
//                                             <feature.icon className="h-7 w-7 text-white" />
//                                         </div>

//                                         <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3>
//                                         <p className="text-sm text-gray-500 leading-relaxed mb-4">{feature.description}</p>

//                                         <div className="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full">
//                                             {feature.stats}
//                                         </div>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </section>

//                     {/* Values Section */}
//                     <section className="max-w-7xl mx-auto px-6 pb-24">
//                         <div className="text-center max-w-2xl mx-auto mb-16">
//                             <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-4">
//                                 <Heart className="h-4 w-4 text-indigo-600" />
//                                 <span className="text-sm font-medium text-indigo-600">Our Values</span>
//                             </div>
//                             <h2 className="text-4xl font-bold text-gray-900 mb-4">
//                                 What Drives Us Forward
//                             </h2>
//                             <p className="text-lg text-gray-500">
//                                 Principles that guide every decision we make
//                             </p>
//                         </div>

//                         {/* <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//                             {values.map((value, i) => (
//                                 <div key={i} className="group p-8 rounded-2xl border border-gray-100 hover:border-gray-200 transition-all">
//                                     <div className={`w-14 h-14 ${value.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
//                                         <value.icon className={`h-7 w-7 ${value.iconColor}`} />
//                                     </div>

//                                     <h3 className="text-lg font-semibold text-gray-900 mb-3">{value.title}</h3>
//                                     <p className="text-sm text-gray-500 leading-relaxed">{value.description}</p>
//                                 </div>
//                             ))}
//                         </div> */}

//                         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
//                             {values.map((value, i) => (
//                                 <div
//                                     key={i}
//                                     className="group p-8 rounded-2xl 
//                                             bg-[#ffffff80] backdrop-blur-[10px]
//                                             border border-[#e6e6e6] 
//                                             hover:border-gray-200 
//                                             transition-all duration-300"
//                                 >
//                                     <div className={`w-14 h-14 ${value.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
//                                         <value.icon className={`h-7 w-7 ${value.iconColor}`} />
//                                     </div>

//                                     <h3 className="text-lg font-semibold text-gray-900 mb-3">
//                                         {value.title}
//                                     </h3>
//                                     <p className="text-sm text-gray-500 leading-relaxed">
//                                         {value.description}
//                                     </p>
//                                 </div>
//                             ))}
//                         </div>

//                     </section>

//                     {/* CTA Section with gradient */}
//                     <section className="max-w-7xl mx-auto px-6 pb-28">
//                         <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white p-16 text-center shadow-2xl">

//                             <div className="relative">
//                                 <h2 className="text-4xl md:text-5xl font-bold mb-4">
//                                     Start Creating CTV Ads Today
//                                 </h2>

//                                 <p className="text-indigo-100 text-lg mb-8 max-w-2xl mx-auto">
//                                     Turn your social videos into powerful TV ads in minutes. Join thousands of brands already using SocialTV.
//                                 </p>

//                                 <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                                     <div
//                                         onClick={() => setShowAuth(true)}
//                                         className="cursor-pointer inline-flex items-center justify-center gap-2 bg-white text-indigo-600 px-8 py-4 rounded-xl font-medium hover:bg-gray-100 transition-all hover:scale-105 active:scale-95 shadow-lg"
//                                     >
//                                         Start Free Trial
//                                         <ArrowRight className="h-4 w-4" />
//                                     </div>

//                                     <Link
//                                         to="/contact"
//                                         className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-8 py-4 rounded-xl font-medium hover:bg-white/20 transition-all"
//                                     >
//                                         Contact Sales
//                                     </Link>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//             </div>

//             <AuthPopup
//                 isOpen={showAuth}
//                 onClose={() => setShowAuth(false)}
//             />


//             {/* ================= FOOTER ================= */}
//             <Footer />

//         </div>
//     );
// };

// export default About;

import { Link } from "react-router-dom";
import {
    Users,
    Globe,
    Zap,
    TrendingUp,
    Sparkles,
    ArrowRight,
    Target,
    Rocket,
    Heart,
    Shield,
    Play,
    Award,
    Star,
    MonitorSmartphone,
    BadgeCheck,
    Video,
    Palette,
    BarChart3,
    Clock,
    CheckCircle,
    Mail,
    MessageCircle,
    Instagram,
    Youtube,
    Facebook,
    Twitter,
} from "lucide-react";
import BackToTop from "../../components/BackToTop/BackToTop";
import { useEffect, useState, useRef } from "react";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import HeroBg from "../../../src/images/hero-bg.png";
import AuthPopup from "../../components/popup/AuthPopup";

const About = () => {
    const [showAuth, setShowAuth] = useState(false);
    const videoRef = useRef(null);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    // Platform features updated with brand colors
    // const features = [
    //     {
    //         icon: Video,
    //         title: "Social to TV Conversion",
    //         description: "Transform Instagram Reels, TikTok videos, and YouTube content into TV-ready ads automatically.",
    //         color: "from-[#ff6968] to-[#ff8a7a]",
    //         stats: "3x faster creation",
    //         bgColor: "bg-[#ff6968]/10"
    //     },
    //     {
    //         icon: MonitorSmartphone,
    //         title: "Multi-Platform Delivery",
    //         description: "Deploy campaigns across Roku, Amazon Fire TV, Samsung TV, and Apple TV with one click.",
    //         color: "from-[#ff6968] to-[#ff8a7a]",
    //         stats: "10+ platforms",
    //         bgColor: "bg-[#ff6968]/10"
    //     },
    //     {
    //         icon: BarChart3,
    //         title: "Real-Time Analytics",
    //         description: "Track performance across all channels with unified dashboard and actionable insights.",
    //         color: "from-[#ff6968] to-[#ff8a7a]",
    //         stats: "Live reporting",
    //         bgColor: "bg-[#ff6968]/10"
    //     },
    //     {
    //         icon: Palette,
    //         title: "Creative Optimization",
    //         description: "AI-powered tools to enhance and adapt your social content for the big screen.",
    //         color: "from-[#ff6968] to-[#ff8a7a]",
    //         stats: "4K quality",
    //         bgColor: "bg-[#ff6968]/10"
    //     }
    // ];
    const features = [
        {
            icon: Video,
            title: "Social to TV Conversion",
            description: "Transform Instagram Reels, TikTok videos, and YouTube content into TV-ready ads automatically.",
            color: "from-blue-500 to-cyan-500",
            stats: "3x faster creation"
        },
        {
            icon: MonitorSmartphone,
            title: "Multi-Platform Delivery",
            description: "Deploy campaigns across Roku, Amazon Fire TV, Samsung TV, and Apple TV with one click.",
            color: "from-purple-500 to-pink-500",
            stats: "10+ platforms"
        },
        {
            icon: BarChart3,
            title: "Real-Time Analytics",
            description: "Track performance across all channels with unified dashboard and actionable insights.",
            color: "from-green-500 to-emerald-500",
            stats: "Live reporting"
        },
        {
            icon: Palette,
            title: "Creative Optimization",
            description: "AI-powered tools to enhance and adapt your social content for the big screen.",
            color: "from-orange-500 to-red-500",
            stats: "4K quality"
        }
    ];

    // Statistics with icons
    const stats = [
        { value: "10K+", label: "Ads Generated", icon: Play, change: "+156% YoY", color: "text-[#ff6968]" },
        { value: "4K+", label: "Active Brands", icon: Users, change: "+89% YoY", color: "text-[#ff6968]" },
        { value: "120+", label: "Countries", icon: Globe, change: "Global reach", color: "text-[#ff6968]" },
        { value: "98%", label: "Satisfaction", icon: Star, change: "Top rated", color: "text-[#ff6968]" }
    ];

    // Values with descriptions
    // const values = [
    //     {
    //         icon: Rocket,
    //         title: "Innovation First",
    //         description: "We're constantly pushing the boundaries of what's possible in advertising technology.",
    //         color: "bg-[#ff6968]/10",
    //         iconColor: "text-[#ff6968]",
    //         borderColor: "border-[#ff6968]/20"
    //     },
    //     {
    //         icon: Heart,
    //         title: "Customer Obsessed",
    //         description: "Your success is our success. We build features that solve real problems.",
    //         color: "bg-[#ff6968]/10",
    //         iconColor: "text-[#ff6968]",
    //         borderColor: "border-[#ff6968]/20"
    //     },
    //     {
    //         icon: Shield,
    //         title: "Trust & Transparency",
    //         description: "Clear pricing, honest communication, and data privacy are our foundations.",
    //         color: "bg-[#ff6968]/10",
    //         iconColor: "text-[#ff6968]",
    //         borderColor: "border-[#ff6968]/20"
    //     },
    //     {
    //         icon: Target,
    //         title: "Results Driven",
    //         description: "Every feature is measured by the impact it creates for our customers.",
    //         color: "bg-[#ff6968]/10",
    //         iconColor: "text-[#ff6968]",
    //         borderColor: "border-[#ff6968]/20"
    //     }
    // ];
    const values = [
        {
            icon: Rocket,
            title: "Innovation First",
            description: "We're constantly pushing the boundaries of what's possible in advertising technology.",
            color: "bg-blue-50",
            iconColor: "text-blue-600"
        },
        {
            icon: Heart,
            title: "Customer Obsessed",
            description: "Your success is our success. We build features that solve real problems.",
            color: "bg-red-50",
            iconColor: "text-red-600"
        },
        {
            icon: Shield,
            title: "Trust & Transparency",
            description: "Clear pricing, honest communication, and data privacy are our foundations.",
            color: "bg-green-50",
            iconColor: "text-green-600"
        },
        {
            icon: Target,
            title: "Results Driven",
            description: "Every feature is measured by the impact it creates for our customers.",
            color: "bg-purple-50",
            iconColor: "text-purple-600"
        }
    ];

    // Team members
    const teamMembers = [
        {
            name: "Sarah Johnson",
            role: "CEO & Co-Founder",
            image: "https://images.unsplash.com/photo-1494790108777-466d103eb9cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            social: { twitter: "#", linkedin: "#" }
        },
        {
            name: "Michael Chen",
            role: "CTO & Co-Founder",
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            social: { twitter: "#", linkedin: "#" }
        },
        {
            name: "Emily Rodriguez",
            role: "Head of Product",
            image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            social: { twitter: "#", linkedin: "#" }
        },
        {
            name: "David Kim",
            role: "Head of Engineering",
            image: "https://images.unsplash.com/photo-1500648767791-00dcc994a37e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            social: { twitter: "#", linkedin: "#" }
        }
    ];

    // Testimonials
    const testimonials = [
        {
            name: "Alex Thompson",
            role: "CMO, TechFlow Inc.",
            content: "SocialTV has completely transformed our advertising strategy. We've seen a 300% increase in engagement since switching.",
            image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            rating: 5
        },
        {
            name: "Jessica Martinez",
            role: "Head of Marketing, GrowthHub",
            content: "The ability to repurpose our social content for TV has been a game-changer. It's saved us countless hours and resources.",
            image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            rating: 5
        },
        {
            name: "Ryan Patel",
            role: "Director of Advertising, BrandWave",
            content: "The analytics dashboard gives us unprecedented insight into our TV campaign performance. Absolutely indispensable.",
            image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&h=200&q=80",
            rating: 4
        }
    ];

    useEffect(() => {
        window.scrollTo(0, 0);

        // // Initialize AOS
        // AOS.init({
        //     duration: 800,
        //     once: false,
        //     mirror: true,
        //     offset: 50,
        //     easing: 'ease-out-cubic',
        //     anchorPlacement: 'top-bottom',
        // });

        // // Refresh AOS on dynamic content changes
        // AOS.refresh();
    }, []);

    return (
        <div className="bg-gradient-to-b from-[#f6f5ea]/20 to-white">
            <BackToTop />

            {/* ================= HEADER ================= */}
            <Header loginClick={() => { setShowAuth(true) }} />

            <div className="relative">
                {/* Hero Background with overlay */}
                <div className="absolute inset-0 w-full h-full">
                    {/* <img
                        src={HeroBg}
                        loading="lazy"
                        sizes="(max-width: 1440px) 100vw, 1440px"
                        alt="hero"
                        className="w-full h-full object-cover"
                    /> */}
                    {/* <div className="absolute inset-0 bg-gradient-to-b from-[#ff6968]/5 via-transparent to-[#ff6968]/5" /> */}
                </div>

                <div className="relative pt-16 md:pt-20">
                    {/* ================= HERO SECTION ================= */}
                    <section className="relative max-w-7xl mx-auto px-6 py-20 overflow-hidden">
                        {/* Animated decorative elements */}
                        <div className="absolute top-20 right-20 w-64 h-64 bg-[#ff6968]/5 rounded-full blur-3xl animate-float-slow" />
                        <div className="absolute bottom-20 left-20 w-64 h-64 bg-[#ff6968]/5 rounded-full blur-3xl animate-float-slower" />

                        <div className="text-center max-w-4xl mx-auto">
                            <div
                                className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-8 border border-[#ff6968]/20"
                                data-aos="fade-up"
                                data-aos-duration="600"
                            >
                                <Sparkles className="h-4 w-4 text-[#ff6968]" />
                                <span className="text-sm font-medium text-[#ff6968]">
                                    About SocialTV
                                </span>
                            </div>

                            <h1
                                className="text-5xl md:text-6xl font-bold text-[#27271f] mb-8 leading-tight"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                Turning Social Content Into{' '}
                                <span className="relative">
                                    <span className="bg-gradient-to-r from-[#ff6968] to-[#ff8a7a] bg-clip-text text-transparent">
                                        TV Ads
                                    </span>
                                    <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-[#ff6968] to-[#ff8a7a] rounded-full" />
                                </span>
                            </h1>

                            <p
                                className="text-xl text-[#3b3b3b] max-w-3xl mx-auto leading-relaxed"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                SocialTV helps brands transform their social media videos into
                                powerful Connected TV ads in minutes. Our platform bridges the gap
                                between social content and premium TV advertising.
                            </p>

                            {/* Trust indicators */}
                            <div
                                className="flex flex-wrap items-center justify-center gap-6 mt-12"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="300"
                            >
                                <div className="flex items-center gap-3 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-[#ff6968]/10">
                                    <div className="flex -space-x-2">
                                        {[1, 2, 3, 4].map((i) => (
                                            <img
                                                key={i}
                                                src={`https://i.pravatar.cc/32?img=${i}`}
                                                className="w-8 h-8 rounded-full border-2 border-white hover:scale-110 transition-transform cursor-pointer"
                                                alt="User"
                                            />
                                        ))}
                                    </div>
                                    <span className="text-sm text-[#3b3b3b]">Trusted by <span className="font-semibold text-[#ff6968]">4,000+</span> brands</span>
                                </div>

                                <div className="h-8 w-px bg-[#ff6968]/20 hidden sm:block" />

                                <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-[#ff6968]/10">
                                    <div className="flex items-center gap-0.5">
                                        {[...Array(5)].map((_, i) => (
                                            <Star key={i} className="h-4 w-4 fill-[#ff6968] text-[#ff6968]" />
                                        ))}
                                    </div>
                                    <span className="text-sm font-medium text-[#27271f]">4.9/5</span>
                                    <span className="text-sm text-[#3b3b3b]">rating</span>
                                </div>

                                <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full border border-[#ff6968]/10">
                                    <Clock className="h-4 w-4 text-[#ff6968]" />
                                    <span className="text-sm text-[#3b3b3b]">30 sec <span className="font-semibold text-[#ff6968]">processing</span></span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* ================= STATS SECTION ================= */}
                    <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="grid md:grid-cols-4 gap-6">
                            {stats.map((stat, i) => (
                                <div
                                    key={i}
                                    className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl border border-[#ff6968]/10 hover:border-[#ff6968]/30 hover:shadow-xl transition-all hover:-translate-y-1"
                                    data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-delay={i * 100}
                                >
                                    <div className="absolute inset-0 bg-gradient-to-br from-[#ff6968]/5 to-[#ff8a7a]/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity" />

                                    <div className="relative">
                                        <div className="w-12 h-12 bg-[#ff6968]/10 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                                            <stat.icon className={`h-6 w-6 ${stat.color}`} />
                                        </div>

                                        <h3 className="text-3xl font-bold text-[#27271f] mb-1">{stat.value}</h3>
                                        <p className="text-sm text-[#3b3b3b] mb-3">{stat.label}</p>

                                        <div className="inline-flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full">
                                            <TrendingUp className="h-3 w-3" />
                                            {stat.change}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* ================= STORY SECTION ================= */}
                    <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="grid lg:grid-cols-2 gap-16 items-center">
                            <div
                                className="relative"
                                data-aos="fade-right"
                                data-aos-duration="800"
                            >
                                <div className="absolute -inset-4 bg-gradient-to-r from-[#ff6968] to-[#ff8a7a] rounded-3xl blur-xl opacity-20" />
                                <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
                                    <div className="relative">
                                        <img
                                            src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                                            alt="Team collaboration"
                                            className="w-full h-96 object-cover"
                                        />
                                        {/* <div className="absolute inset-0 bg-gradient-to-t from-[#27271f]/60 to-transparent" /> */}

                                        {/* Play button overlay */}
                                        {/* <div className="absolute inset-0 flex items-center justify-center">
                                            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/30 hover:scale-110 transition-transform duration-300 cursor-pointer group">
                                                <Play className="w-8 h-8 text-white fill-white ml-1 group-hover:scale-110 transition-transform" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div data-aos="fade-left" data-aos-duration="800">
                                <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-[#ff6968]/20">
                                    <Target className="h-4 w-4 text-[#ff6968]" />
                                    <span className="text-sm font-medium text-[#ff6968]">Our Mission</span>
                                </div>

                                <h2 className="text-4xl font-bold text-[#27271f] mb-6">
                                    Bridging Social &{' '}
                                    <span className="text-[#ff6968]">Television</span>
                                </h2>

                                <div className="space-y-4 text-[#3b3b3b]">
                                    <p className="leading-relaxed">
                                        Advertising is evolving. Social media has become the most powerful
                                        form of storytelling, but television remains the most trusted
                                        screen in the home.
                                    </p>

                                    <p className="leading-relaxed">
                                        SocialTV was created to connect these two worlds — enabling
                                        businesses to easily transform social content into high-quality
                                        TV-ready ads.
                                    </p>

                                    <p className="leading-relaxed">
                                        Our platform simplifies the entire workflow, allowing brands,
                                        agencies, and creators to launch TV campaigns faster than ever
                                        before.
                                    </p>
                                </div>

                                {/* Company highlights */}
                                <div className="grid grid-cols-2 gap-4 mt-8">
                                    <div className="flex items-center gap-3 bg-white/80 backdrop-blur-sm p-3 rounded-xl border border-[#ff6968]/10 hover:shadow-md transition-all">
                                        <div className="w-10 h-10 bg-[#ff6968]/10 rounded-lg flex items-center justify-center">
                                            <BadgeCheck className="h-5 w-5 text-[#ff6968]" />
                                        </div>
                                        <div>
                                            <div className="font-medium text-[#27271f]">ISO Certified</div>
                                            <div className="text-xs text-[#3b3b3b]">Security & privacy</div>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-3 bg-white/80 backdrop-blur-sm p-3 rounded-xl border border-[#ff6968]/10 hover:shadow-md transition-all">
                                        <div className="w-10 h-10 bg-[#ff6968]/10 rounded-lg flex items-center justify-center">
                                            <Award className="h-5 w-5 text-[#ff6968]" />
                                        </div>
                                        <div>
                                            <div className="font-medium text-[#27271f]">Award Winning</div>
                                            <div className="text-xs text-[#3b3b3b]">Best AdTech 2024</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* ================= FEATURES SECTION ================= */}
                    <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="text-center max-w-2xl mx-auto mb-16">
                            <div
                                className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-[#ff6968]/20"
                                data-aos="fade-up"
                            >
                                <Zap className="h-4 w-4 text-[#ff6968]" />
                                <span className="text-sm font-medium text-[#ff6968]">Platform Features</span>
                            </div>
                            <h2
                                className="text-4xl font-bold text-[#27271f] mb-4"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                Everything You Need to Succeed
                            </h2>
                            <p
                                className="text-lg text-[#3b3b3b]"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                Powerful tools that make TV advertising accessible to everyone
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {features.map((feature, i) => (
                                <div
                                    key={i}
                                    className="group relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl border border-[#ff6968]/10  transition-all hover:-translate-y-1"
                                    data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-delay={i * 100}
                                >
                                    <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity`} />

                                    <div className="relative">
                                        <div className={`w-14 h-14 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                                            <feature.icon className="h-7 w-7 text-white" />
                                        </div>

                                        <h3 className="text-lg font-semibold text-[#27271f] mb-3">{feature.title}</h3>
                                        <p className="text-sm text-[#3b3b3b] leading-relaxed mb-4">{feature.description}</p>

                                        <div className="inline-flex items-center gap-1 text-xs font-medium text-[#ff6968] bg-[#ff6968]/10 px-3 py-1.5 rounded-full">
                                            <CheckCircle className="h-3 w-3" />
                                            {feature.stats}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* ================= VALUES SECTION ================= */}
                    <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="text-center max-w-2xl mx-auto mb-16">
                            <div
                                className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-[#ff6968]/20"
                                data-aos="fade-up"
                            >
                                <Heart className="h-4 w-4 text-[#ff6968]" />
                                <span className="text-sm font-medium text-[#ff6968]">Our Values</span>
                            </div>
                            <h2
                                className="text-4xl font-bold text-[#27271f] mb-4"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                What Drives Us Forward
                            </h2>
                            <p
                                className="text-lg text-[#3b3b3b]"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                Principles that guide every decision we make
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {values.map((value, i) => (
                                <div
                                    key={i}
                                    className="group p-8 rounded-2xl bg-white/80 backdrop-blur-sm border border-[#ff6968]/10 hover:border-[#ff6968]/30 hover:shadow-xl transition-all hover:-translate-y-1"
                                    data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-delay={i * 100}
                                >
                                    <div className={`w-14 h-14 ${value.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                                        <value.icon className={`h-7 w-7 ${value.iconColor}`} />
                                    </div>

                                    <h3 className="text-lg font-semibold text-[#27271f] mb-3">
                                        {value.title}
                                    </h3>
                                    <p className="text-sm text-[#3b3b3b] leading-relaxed">
                                        {value.description}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* ================= TEAM SECTION ================= */}
                    {/* <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="text-center max-w-2xl mx-auto mb-16">
                            <div
                                className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-[#ff6968]/20"
                                data-aos="fade-up"
                            >
                                <Users className="h-4 w-4 text-[#ff6968]" />
                                <span className="text-sm font-medium text-[#ff6968]">Our Team</span>
                            </div>
                            <h2
                                className="text-4xl font-bold text-[#27271f] mb-4"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                Meet the People Behind SocialTV
                            </h2>
                            <p
                                className="text-lg text-[#3b3b3b]"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                Passionate innovators dedicated to revolutionizing TV advertising
                            </p>
                        </div>

                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                            {teamMembers.map((member, i) => (
                                <div
                                    key={i}
                                    className="group bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden border border-[#ff6968]/10 hover:border-[#ff6968]/30 hover:shadow-xl transition-all hover:-translate-y-1"
                                    data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-delay={i * 100}
                                >
                                    <div className="relative overflow-hidden">
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#27271f]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                                    </div>
                                    <div className="p-6 text-center">
                                        <h3 className="text-lg font-semibold text-[#27271f] mb-1">{member.name}</h3>
                                        <p className="text-sm text-[#ff6968] mb-3">{member.role}</p>
                                        <div className="flex items-center justify-center gap-2">
                                            <a href={member.social.twitter} className="w-8 h-8 bg-[#ff6968]/10 rounded-full flex items-center justify-center hover:bg-[#ff6968] hover:text-white transition-colors group">
                                                <Twitter className="h-4 w-4 text-[#ff6968] group-hover:text-white" />
                                            </a>
                                            <a href={member.social.linkedin} className="w-8 h-8 bg-[#ff6968]/10 rounded-full flex items-center justify-center hover:bg-[#ff6968] hover:text-white transition-colors group">
                                                <Users className="h-4 w-4 text-[#ff6968] group-hover:text-white" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section> */}

                    {/* ================= TESTIMONIALS SECTION ================= */}
                    {/* <section className="max-w-7xl mx-auto px-6 pb-24">
                        <div className="text-center max-w-2xl mx-auto mb-16">
                            <div
                                className="inline-flex items-center gap-2 bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-[#ff6968]/20"
                                data-aos="fade-up"
                            >
                                <MessageCircle className="h-4 w-4 text-[#ff6968]" />
                                <span className="text-sm font-medium text-[#ff6968]">Testimonials</span>
                            </div>
                            <h2
                                className="text-4xl font-bold text-[#27271f] mb-4"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >
                                What Our Clients Say
                            </h2>
                            <p
                                className="text-lg text-[#3b3b3b]"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                Real stories from brands transforming their advertising strategy
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-6">
                            {testimonials.map((testimonial, i) => (
                                <div
                                    key={i}
                                    className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl border border-[#ff6968]/10 hover:border-[#ff6968]/30 hover:shadow-xl transition-all hover:-translate-y-1"
                                    data-aos="fade-up"
                                    data-aos-duration="600"
                                    data-aos-delay={i * 100}
                                >
                                    <div className="flex items-center gap-0.5 mb-4">
                                        {[...Array(5)].map((_, j) => (
                                            <Star
                                                key={j}
                                                className={`h-4 w-4 ${j < testimonial.rating ? 'fill-[#ff6968] text-[#ff6968]' : 'fill-gray-200 text-gray-200'}`}
                                            />
                                        ))}
                                    </div>
                                    <p className="text-[#3b3b3b] leading-relaxed mb-6">
                                        "{testimonial.content}"
                                    </p>
                                    <div className="flex items-center gap-3">
                                        <img
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            className="w-12 h-12 rounded-full object-cover border-2 border-[#ff6968]/20"
                                        />
                                        <div>
                                            <h4 className="font-semibold text-[#27271f]">{testimonial.name}</h4>
                                            <p className="text-sm text-[#3b3b3b]">{testimonial.role}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section> */}

                    {/* ================= CTA SECTION ================= */}
                    <section className="max-w-7xl mx-auto px-6 pb-28">
                        <div
                            className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#ff6968] via-[#ff8a7a] to-[#ff6968] text-white p-16 text-center shadow-2xl"
                            data-aos="zoom-in"
                            data-aos-duration="800"
                        >
                            {/* Decorative elements */}
                            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl" />
                            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl" />

                            <div className="relative">
                                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20">
                                    <Rocket className="h-4 w-4" />
                                    <span className="text-sm font-medium">Get Started Today</span>
                                </div>

                                <h2 className="text-4xl md:text-5xl font-bold mb-4">
                                    Start Creating CTV Ads Today
                                </h2>

                                <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
                                    Turn your social videos into powerful TV ads in minutes. Join thousands of brands already using SocialTV.
                                </p>

                                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                                    <button
                                        onClick={() => setShowAuth(true)}
                                        className="group inline-flex items-center justify-center gap-2 bg-white text-[#ff6968] px-8 py-4 rounded-xl font-medium hover:bg-gray-100 transition-all hover:scale-105 active:scale-95 shadow-lg"
                                    >
                                        Start Free Trial
                                        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                                    </button>

                                    <Link
                                        to="/contact"
                                        className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-8 py-4 rounded-xl font-medium hover:bg-white/20 transition-all"
                                    >
                                        Contact Sales
                                    </Link>
                                </div>

                                {/* Trust badges */}
                                <div className="flex flex-wrap items-center justify-center gap-6 mt-8 pt-8 border-t border-white/20">
                                    <div className="flex items-center gap-2">
                                        <Shield className="h-4 w-4 text-white/80" />
                                        <span className="text-sm text-white/80">Secure & Private</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <Zap className="h-4 w-4 text-white/80" />
                                        <span className="text-sm text-white/80">30 Sec Processing</span>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <CheckCircle className="h-4 w-4 text-white/80" />
                                        <span className="text-sm text-white/80">No Credit Card Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <AuthPopup
                isOpen={showAuth}
                onClose={() => setShowAuth(false)}
            />

            {/* ================= FOOTER ================= */}
            <Footer />
        </div>
    );
};

export default About;